__webpack_require__.p = "/yummy-restaurant-website/";